<div
    *ngIf="ravenModuleEnabled && ravenValidConfig"
    [ngClass]="layout === 'two-columns' ? 'raven-grid' : 'raven-stack'"
    [class.has-consent]="showConsent">

    <div class="g-cat m-input-group">
        <label class="m-input-group-name asterisk-mark">Categories:</label>
        <div class="m-input-group-value">
            <p-multiSelect
                class="p-multiselect-label"
                id="category-multiselect"
                [(ngModel)]="categoriesInput"
                (ngModelChange)="categoriesChanged($event)"
                [options]="categoryOptions"
                [style]="{ 'max-width': '700px', overflow: 'hidden', 'text-overflow': 'ellipsis' }"
                (completeMethod)="filterCategoryChanged($event.query)"
                placeholder="Please select"
                optionLabel="fullName"
                dataKey="id"
                [readonly]="isIssueClosed"
                [required]="true"
                [disabled]="archivedLog"
                appendTo="body">
            </p-multiSelect>
        </div>
    </div>

    <div class="g-pri m-input-group">
        <label class="m-input-group-name asterisk-mark">Priority:</label>
        <div class="m-input-group-value">
            <p-dropdown
                id="priority-dropdown"
                [(ngModel)]="priorityInput"
                (ngModelChange)="priorityChanged($event)"
                [options]="priorityOptions"
                [style]="{ width: '100%' }"
                (completeMethod)="filterPriorityChanged($event.query)"
                placeholder="Please select"
                minLength="1"
                [disabled]="archivedLog"
                optionLabel="name"
                [readonly]="isIssueClosed"
                appendTo="body">
            </p-dropdown>
            <div *ngIf="priorityInput && priorityInput.suggested" class="suggested-label">Suggested</div>
        </div>
    </div>

    <div class="g-evt m-input-group">
        <label class="m-input-group-name asterisk-mark">Event:</label>
        <div class="m-input-group-value">
            <p-dropdown
                id="event-dropdown"
                [(ngModel)]="selectedEvent"
                (ngModelChange)="eventChanged($event)"
                [options]="eventsOptions"
                [style]="{ width: '100%' }"
                placeholder="Please select"
                minLength="1"
                optionLabel="name"
                [disabled]="archivedLog"
                [readonly]="isIssueClosed"
                appendTo="body">
            </p-dropdown>
        </div>

        <div *ngIf="!archivedLog" class="flex align-items-center mt-2">
            <p-checkbox
                [(ngModel)]="defaultEvent"
                (ngModelChange)="setDefaultEvent()"
                [disabled]="defaultEvent"
                [binary]="true"
                name="defaultEvent"
                label="Set As Default Event"
                styleClass="mr-2">
            </p-checkbox>
        </div>

        <label *ngIf="archivedLog" class="archived-label mt-2">Event is archived in Raven</label>
    </div>

    <div class="g-loc m-input-group">
        <label class="m-input-group-name asterisk-mark">Location:</label>
        <div class="m-input-group-value">
            <p-dropdown
                id="location-dropdown"
                [(ngModel)]="locationInput"
                (ngModelChange)="locationChanged($event)"
                [options]="locationsOptions"
                [style]="{ width: '100%' }"
                (completeMethod)="filterLocationChanged($event.query)"
                placeholder="Please select"
                minLength="1"
                optionLabel="name"
                [disabled]="archivedLog || !selectedEvent || !categoriesInput || categoriesInput.length === 0 || !priorityInput"
                [readonly]="isIssueClosed || !selectedEvent || !categoriesInput || categoriesInput.length === 0 || !priorityInput"
                appendTo="body">
            </p-dropdown>
        </div>
    </div>

    @if (showConsent) {
    <div class="g-con m-input-group">
        <div class="label-with-info">
            <label class="m-input-group-name asterisk-mark">Patient Consent:</label>
            <!-- The info icon -->
            <button
                doNotPropagateClick
                pButton
                pRipple
                type="button"
                icon="pi pi-info-circle"
                class="p-button-secondary p-button-rounded p-button-text label-info-btn"
                (click)="episodeInfo.toggle($event)"></button>
        </div>

        <div class="m-input-group-value">
            <p-dropdown
                id="consent-dropdown"
                [(ngModel)]="consentInput"
                (ngModelChange)="consentChanged($event)"
                [options]="consentOptions"
                [style]="{ width: '100%' }"
                placeholder="Please select"
                minLength="1"
                optionLabel="label"
                appendTo="body">
            </p-dropdown>
        </div>

        <!-- The overlay panel -->
        <p-overlayPanel #episodeInfo appendTo="body">
            <div class="episode-info">
                <p>Does the patient consent to sharing this information with the organisation's clinical safety officer?</p>
                <p>This information will only be used to complete legally required clinical incident reports.</p>
            </div>
        </p-overlayPanel>
    </div>
    }
</div>

<div *ngIf="showNotes && ravenModuleEnabled && ravenValidConfig" class="raven-notes m-input-group">
    <label class="m-input-group-name">Raven Notes:</label>
    <div class="m-input-group-value">
        <textarea
            id="raven-notes"
            rows="8"
            pInputTextarea
            [(ngModel)]="notesInput"
            (ngModelChange)="notesChanged($event)"
            [readonly]="isIssueClosed"
            [style.resize]="'none'"></textarea>
    </div>
</div>
